import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'generic-form-buttons',
    templateUrl: './generic-form-buttons.component.html',
    styleUrls: ['../widgets-custom-theme.scss', './generic-form-buttons.component.scss']
})
export class GenericFormButtonsComponent implements OnInit {
    @Input('button-icon') buttonIcon: string = '';
    @Input('button-string') buttonString: string = '';
    @Input('buttonActive') buttonActive: boolean = false;

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/widgets/generic-form-buttons/generic-form-buttons.component.ts